import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const DropdownThemeContext = createContext('dark');
/** TODO */
function useDropdownTheme() {
    return useContext(DropdownThemeContext);
}
/** TODO */
function DropdownThemeProvider({ mode, children }) {
    return jsx(DropdownThemeContext.Provider, { value: mode, children: children });
}
DropdownThemeProvider.displayName = 'DropdownThemeProvider';

export { DropdownThemeProvider, useDropdownTheme };
//# sourceMappingURL=dropdown-theme.js.map
